import React from 'react';
import './ButtonList.css';

export interface ButtonListItem {
  id: string;
  label: string;
  onClick: () => void;
  disabled?: boolean;
  icon?: string;
  variant?: 'default' | 'danger' | 'success' | 'warning';
}

export interface ButtonListProps {
  items: ButtonListItem[];
  className?: string;
  showDividers?: boolean;
  spacing?: 'compact' | 'normal' | 'relaxed';
}

const ButtonList: React.FC<ButtonListProps> = ({
  items,
  className = '',
  showDividers = true,
  spacing = 'normal'
}) => {
  const listClasses = [
    'button-list',
    `button-list--${spacing}`,
    showDividers ? 'button-list--with-dividers' : '',
    className
  ].filter(Boolean).join(' ');

  return (
    <div className={listClasses}>
      {items.map((item, index) => (
        <React.Fragment key={item.id}>
          <button
            className={`button-list__item button-list__item--${item.variant || 'default'}`}
            onClick={item.onClick}
            disabled={item.disabled}
          >
            {item.icon && <i className={`button-list__icon ${item.icon}`}></i>}
            <span className="button-list__label">{item.label}</span>
          </button>
          {showDividers && index < items.length - 1 && (
            <div className="button-list__divider"></div>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default ButtonList;
